<script>
  /* global Global */
  import SmallTitle from '../common/SmallTitle.svelte';
  import IconButton from '../common/IconButton.svelte';
  import Pipe from '../symbols/Pipe.svelte';
  import Common from '../js/common.js';

  export let value;
  export let lang = undefined;

  let valueInternal;

  let previewLang = 'cs';

  const i18n = {
    title: {
      cs: 'Nadpis',
      en: 'Title',
    },
    articlePreview: {
      cs: 'Náhled článku',
      en: 'Article preview',
    },
  };

  const projectStyle = Global.project.style;
</script>

<div class='article-preview' class:article-preview-old={projectStyle === 'old' || projectStyle === 'sharp'}>
  <div class='article-preview-language'>
    <IconButton icon='translate' onClick={() => { previewLang = previewLang !== 'en' ? 'en' : 'cs'; }}/>
  </div>

  <div class='article-preview-refresh'>
    <IconButton icon='refresh' onClick={() => { valueInternal = Common.deepCopy(value); }}/>
  </div>

  <div class='article-preview-small-title'>
    <SmallTitle value={i18n.articlePreview[lang]} small={true}/>
  </div>

  {#if valueInternal?.title[previewLang]}
    <div class='article-preview-title'>
      {valueInternal.title[previewLang]}
    </div>
  {/if}

  {#if valueInternal?.perex[previewLang]}
    <div class='article-preview-perex'>
      {@html Common.escapeMarkdown(valueInternal.perex[previewLang], false, true)}
    </div>
  {/if}

  {#if valueInternal?.content[previewLang]}
    <div class='article-preview-content'>
      {@html Common.escapeMarkdown(valueInternal.content[previewLang], true, true)}
    </div>
  {/if}

  {#if valueInternal?.author.firstName || valueInternal?.author.lastName || valueInternal?.date}
    <div class='article-preview-author-and-date'>
      {valueInternal.author.firstName} {valueInternal.author.lastName}
      {#if (valueInternal.author.firstName || valueInternal.author.lastName) && valueInternal.date} <Pipe/> {/if}
      {valueInternal.date}
    </div>
  {/if}
</div>

<style>
  .article-preview {
    position: relative;

    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .article-preview-language {
    position: absolute;
    right: 30px;

    z-index: 1;
  }

  .article-preview-refresh {
    position: absolute;
    right: 0px;

    z-index: 1;
  }

  .article-preview-title {
    width: fit-content;

    padding: 5px 10px;

    font-family: var(--font-secondary);
    font-size: 32px;
    font-weight: bold;

    background: linear-gradient(135deg, var(--red), var(--dark-red));
    color: var(--white);
  }

  .article-preview-old .article-preview-title {
    background: var(--red);
  }

  .article-preview-perex {
    font-weight: bold;

    line-height: 1.6;

    overflow-wrap: anywhere;
  }

  .article-preview-content {
    line-height: 1.6;

    overflow-wrap: anywhere;
  }

  .article-preview-author-and-date {
    text-align: right;

    color: var(--grey-7);
  }

  :global(body.dark) .article-preview-title {
    background: linear-gradient(135deg, var(--red-dark), var(--dark-red-dark));
  }

  :global(body.dark) .article-preview-old .article-preview-title {
    background: var(--red-dark);
  }

  :global(body.dark) .article-preview-author-and-date {
    color: var(--grey-5);
  }
</style>
